import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class RecorderService {
  data = [];

  addSection(section: string) {
    this.data.push({ section });
  }

  addComment(comment: string) {
    this.data.push({ comment });
  }

  add(label: string, value: number, detail: string) {
    this.data.push({ label, value, detail });
  }
}
